module.exports = __webpack_public_path__ + "img/male_5.5826338a.png";